import type { BroadcastAspect } from "../../lib/broadcastApi";

export const STAGE_SIZES: Record<BroadcastAspect, { w: number; h: number }> = {
  "16:9": { w: 1920, h: 1080 },
  "16:10": { w: 1920, h: 1200 },
};

/** scale = min(windowW / stageW, windowH / stageH). Never NaN/negative. */
export function computeStageScale(
  aspect: BroadcastAspect,
  windowW: number,
  windowH: number,
): number {
  const { w, h } = STAGE_SIZES[aspect] ?? STAGE_SIZES["16:9"];
  const s = Math.min(windowW / w, windowH / h);
  return Number.isFinite(s) && s > 0 ? s : 1;
}

/** Scale as the 4-decimal string exposed on `data-scale`. */
export const formatScale = (s: number): string => s.toFixed(4);
